import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    tickets: {},
    selectedTicketManagementId:'',
    selectedTicketManagementChatIdDetails : {
      selectedChatConversationId:"",
      selectedUserId:"",
      selectedTicketManagementId:""
    }
};


const tickets = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case Actions.GET_TICKET_MANAGEMENT_LIST: {
      draft.tickets = payload?.tickets;
      break;
    }

    case Actions.SELECTED_TICKET_MANAGEMENT_ID: {
      draft.selectedTicketManagementId = payload?.selectedTicketManagementId;
      break;
    }

    case Actions.SELECTED_TICKET_MANAGEMENT_CHAT_ID_DETAILS: {
      draft.selectedTicketManagementChatIdDetails = payload?.selectedTicketManagementChatIdDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default tickets;
